import { Component, OnInit, Directive  } from '@angular/core';


@Component({
    selector: 'app-grid-edit',
    templateUrl: './grid-edit.component.html',
    styleUrls: ['./grid-edit.component.scss'],
    standalone: false
})
export class GridEditComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  params: any;
  agInit(params: any){
    this.params = params; 
  } 
  btnClickedHandler(e) {
    this.params.clicked(this.params.data);
  }

}


@Component({
  selector: 'app-grid-delete',
  template: '<div style="display:flex; align-items: center; height: 100%"><i class="material-icons" (click)="btnClickedHandler($event)" >delete</i></div>',
  styleUrls: ['./grid-edit.component.scss'],
  standalone: false
})
export class GridDeleteComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  params: any;
  agInit(params: any) {
    this.params = params;
  }
  btnClickedHandler(e) {
    this.params.clicked(this.params.value, this.params);
  }

}
